<div class="modal-header">
  <div class="title">
      <!-- <h2 class="modal-title-prefix"><span translate="DOKUMENT.SINGULAR.OTKUPEFEKTIVE"></span></h2> -->
      <h1 class="modal-title">
          <!-- <span translate="DOKUMENT.SINGULAR.TITLE"></span> -->
          <span translate="{{_modelData.MainTitle}}"></span>
      </h1>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-header mt-0 mb-0 pt-1 pb-1">
  <button type="button" class="btn btn-outline-primary" (click)="Save()"><span class="fa fa-fw fa-save"></span></button>
</div>
<div class="modal-body">
  <yt-dokument-update #baseUpdate></yt-dokument-update>
</div>
<div class="modal-footer">
  <!-- <button type="submit" class="btn btn-primary" (click)="Save()"><span>Sačuvaj</span></button>
  <button type="button" class="btn btn-secondary" (click)="Close()"><span>Odustani</span></button> -->
  <button type="submit" class="btn btn-primary" (click)="Save(true)"><span [innerHTML]="'FW.ACTION.SAVE.ACTION' | translate">Sačuvaj i zatvori</span></button>  
  <button type="button" class="btn btn-secondary" (click)="Close()"><span [innerHTML]="'FW.ACTION.CANCEL' | translate">Zatvori</span></button>  
</div>
